/*
 * API lấy dữ liệu cho bảng lịch sử sửa chữa.
 * pvduy 02/02/2021
 */
import httpClient from "@/apis/base/axios-httpclient";
import api from "@/apis/UsageHistoryAPI";
import Crud from "./crud-base";
var crud = new Crud("UsageHistory", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "UsageHistoryID",
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  updateLocationForAssets: async function (context, payload) {
    context.commit("updateLoading", true);
    let url = [api.getAPIUrl(), "updateLocationForAssets"];
    if (payload == true) {
      url.push(true);
    }
    let request = {
      url: url.join("/"),
      data: payload,
    };
    let res = await httpClient.postAsync(request);
    context.commit("updateLoading", false);
    if (res.Success) {
      return res;
    } else return null;
  },
  updateManagerForAssets: async function (context, payload) {
    context.commit("updateLoading", true);
    let url = [api.getAPIUrl(), "updateManagerForAssets"];
    if (payload == true) {
      url.push(true);
    }
    let request = {
      url: url.join("/"),
      data: payload,
    };
    let res = await httpClient.postAsync(request);
    context.commit("updateLoading", false);
    if (res.Success) {
      return res;
    } else return null;
  },
  loadAssetQuantityByID: async function (context, payload) {
    let request = {
      url: [api.getAPIUrl(), "quantity-asset", payload.occType, payload.assetID].join("/"),
    };
    return await httpClient.getAsync(request);
  },
  loadNearestRepresentator: async function (context, payload) {
    let request = {
      url: [api.getAPIUrl(), "nearest-representator", payload.occType, payload.orgUnitID].join("/"),
    };
    return await httpClient.getAsync(request);
  },

  getUsageInfoByEmployeeID: async function (context, payload) {
    let request = {
      url: [
        api.getAPIUrl(),
        "nearest-usageinfo-by-employee",
        payload.occurrenceType,
        payload.employeeID,
      ].join("/"),
    };
    return await httpClient.getAsync(request);
  },

  getLastestUsageHistory: async function (context, assetID) {
    let request = {
      url: [api.getAPIUrl(), "getlastestusagehistory", assetID].join("/"),
    };
    return await httpClient.getAsync(request);
  },

  getLastestOccurrenceTypeUsageHistory: async function (context, payload) {
    let request = {
      url: [
        api.getAPIUrl(),
        "get-lastest-occurrencetype-usagehistory",
        payload.assetID,
        payload.occurrenceType,
      ].join("/"),
    };
    return await httpClient.getAsync(request);
  },

  getLastestUsageHistoryByQuantity: async function (context, payload) {
    context.commit("updateLoading", true);
    let request = {
      url: [api.getAPIUrl(), "getlastestusagehistorybyquantity"].join("/"),
      data: payload,
    };
    let res = await httpClient.postAsync(request);
    context.commit("updateLoading", false);
    return res;
  },

  getBeforeStatusAsset: async function (context, payload) {
    context.commit("updateLoading", true);
    let url = [api.getAPIUrl(), "before-asset-status"];
    if (payload == true) {
      url.push(true);
    }
    let request = {
      url: url.join("/"),
      data: payload,
    };
    let res = await httpClient.postAsync(request);
    context.commit("updateLoading", false);
    if (res.length > 0) {
      return res;
    } else return null;
  },

  /**
   * Lấy danh sách các tài sản cấp phát theo số lượng
   * @param {} context
   * @param {*} payload
   * @returns
   */
  getUsageHistoryFullFieldByAssetID: async function (context, payload) {
    context.commit("updateLoading", true);
    let res = await api.getUsageHistoryFullFieldByAssetID(payload);
    context.commit("updateLoading", false);
    if (res) {
      return res;
    }
  },

  /**
   *
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  getUsageHistoryTotalByAssetID: async function (context, payload) {
    let res = await api.getUsageHistoryTotalByAssetID(payload);
    if (res) return res;
    else return null;
  },

  getUsageHistoryByLocationId: async function (context, payload) {
    let res = await api.getUsageHistoryByLocationId(payload);
    if (res) return res;
    else return null;
  },

  getUsageHistoryByUsageHistoryID: async function (context, ids) {
    let res = await api.getUsageHistoryByUsageHistoryID(ids);
    if (res) return res;
    else return null;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
